import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import { NurikaeruFaceSvg } from './assets/NurikaeruFace.svg';

const { tablet, mobile } = mediaQueries();

export const StrongPoint = () => {
  return (
    <div
      css={css`
        max-width: 568px;
        margin-inline: auto;
        padding: 0 1em;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0 25px;
          padding: 20px 1em;
          background-color: #fff;
          border-radius: 8px;

          ${tablet(({ setAutomaticDesignBasedSize }) => css`
            padding: ${setAutomaticDesignBasedSize(20, 8)} 1em;
            gap: 0 ${setAutomaticDesignBasedSize(25, 15)};
          `)}

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            padding: ${setAutomaticDesignBasedSize(20, 8)} 1em;
            gap: 0 ${setAutomaticDesignBasedSize(25, 15)};
          `)}
        `}
      >
        <div
          css={css`
            font-size: 0;
            width: 50px;

            ${tablet(({ setAutomaticDesignBasedSize }) => css`
              width: ${setAutomaticDesignBasedSize(50, 34)};
            `)}

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              width: ${setAutomaticDesignBasedSize(50, 34)};
            `)}
          `}
        >
          <NurikaeruFaceSvg />
        </div>
        <div
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
          `}
        >
          <div
            css={css`
              text-align: center;
              margin-right: 20px;
              padding-right: 20px;
              position: relative;

              &::before {
                content: "";
                width: 1px;
                height: 110%;
                background-color: #ababab;
                border-radius: 8px;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
              }
            `}
          >
            <p
              css={css`
                color: #6d6d6d;
                font-size: 16px;

                ${tablet(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(16, 11)};
                `)}

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(16, 11)};
                `)}
              `}
            >
              ヌリカエ対応エリア
            </p>
            <p
              css={css`
                color: #272343;
                font-size: 20px;
                font-weight: bold;

                ${tablet(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(20, 13)};
                `)}

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(20, 13)};
                `)}
              `}
            >
              全国47都道府県
            </p>
          </div>
          <div
            css={css`
              text-align: center;
            `}
          >
            <p
              css={css`
                color: #6d6d6d;
                font-size: 16px;

                ${tablet(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(16, 11)};
                `)}

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(16, 11)};
                `)}
              `}
            >
              ヌリカエ登録企業数
            </p>
            <p
              css={css`
                color: #272343;
                font-size: 20px;
                font-weight: bold;

                ${tablet(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(20, 13)};
                `)}

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(20, 13)};
                `)}
              `}
            >
              全国
              <span
                css={css`
                  font-size: 23px;

                  ${tablet(({ setAutomaticDesignBasedSize }) => css`
                    font-size: ${setAutomaticDesignBasedSize(23, 16)};
                  `)}

                  ${mobile(({ setAutomaticDesignBasedSize }) => css`
                    font-size: ${setAutomaticDesignBasedSize(23, 16)};
                  `)}
                `}
              >
                4,500
              </span>
              社
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
